import React from "react";
import { Theme } from "../../.themes";
import { makeStyles } from "@material-ui/core";

interface CarImageProps {
    imageUrl?: string;
}

const useStyles = makeStyles((theme: Theme) => ({
    image: {
        width: '100%',
        height: "auto",
        maxWidth: '376.331px',
        [theme.breakpoints.up("md")]: {
            maxWidth: '470.414px',
        },
    },
}));

const CarImage: React.FC<CarImageProps> = (props: CarImageProps) => {
    const classes = useStyles();

    if (!props.imageUrl) {
        return null;
    }

    return (
        <div>
            <img
                src={props.imageUrl}
                alt="VolvoCarImage"
                className={classes.image}
            />
        </div >
    );
};
export default CarImage;